require('./angular');
module.exports = angular;



// WEBPACK FOOTER //
// ./app/vendor/angular/index.js